<mat-toolbar class="top_menu">
    <a
      *ngFor="let itm of navigationItems"
      mat-button
      class="top_menu__button"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      [matMenuTriggerFor]="itm?.title == 'Help' ? menu : null"
      (click)="navigate(itm)">
      {{ itm?.title }}
    </a>
    <mat-menu #menu="matMenu" xPosition="before" class="others__submenu">
        <a mat-menu-item *ngFor="let sub of helpNavigation?.children" class="others__submenu_item" (click)="openSubNavigation(sub)">{{ sub?.title }}</a>
    </mat-menu>
</mat-toolbar>
